import { Link } from "@tanstack/react-router";

function Footer() {
  return (
    <footer className="bg-[#171717] px-5 py-8 text-white sm:px-8 lg:px-10">
      <div className="mx-auto flex max-w-7xl flex-col gap-5 border-t border-white/10 pt-7 text-xs text-white/55 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2">
          <img
            src="/logo-icon.png"
            alt=""
            className="h-6 w-6 object-contain"
            width={220}
            height={220}
            loading="lazy"
          />
          <span className="font-semibold text-white/70">Innovally</span>
          <span>© 2026</span>
        </div>
        <div className="flex flex-wrap gap-5">
          <a href="/#top" className="transition-colors hover:text-white">
            Voltar ao início
          </a>
          <a href="/#contato" className="transition-colors hover:text-white">
            Falar com a equipe
          </a>
          <Link to="/privacidade" className="transition-colors hover:text-white">
            Política de Privacidade
          </Link>
          <Link to="/termos" className="transition-colors hover:text-white">
            Termos de Uso
          </Link>
        </div>
      </div>
    </footer>
  );
}

export { Footer };
